/**
 * The filter dropdown options shared by the notification Type and Master lists.
 *
 * One source so the two screens offer the same categories and channels in the
 * same order — a channel added here appears on both without a second edit. The
 * values are the API's own tokens (what the engine stores and filters on); the
 * labels are the human names shown elsewhere in the UI.
 */
export interface FilterOption {
  label: string;
  value: string;
}

/** notificationCategory — the four seeded classes a type may belong to. */
export const CATEGORY_OPTIONS: FilterOption[] = [
  { label: 'Alert', value: 'ALERT' },
  { label: 'Transactional', value: 'TRANSACTIONAL' },
  { label: 'Promotional', value: 'PROMOTIONAL' },
  { label: 'System', value: 'SYSTEM' },
];

/** Delivery channels, in the column order the matrix uses. */
export const CHANNEL_OPTIONS: FilterOption[] = [
  { label: 'In-App', value: 'inApp' },
  { label: 'Email', value: 'email' },
  { label: 'SMS', value: 'sms' },
  { label: 'Mobile push', value: 'push' },
  { label: 'Browser push', value: 'webPush' },
  { label: 'WhatsApp', value: 'whatsapp' },
];
